<template>
	<div class="wrapper">
		<div class="section page-header header-filter" :style="headerStyle">
			<div class="">
				<div class="md-layout">
					<div class="
							md-layout-item
							md-size-80
							md-small-size-90
							md-xsmall-size-100
							md-medium-size-75
							mx-auto
						">
						<div class="main main-raised" style="margin-top: 90px; margin-bottom: 90px;">
							<Contact />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Contact from "@/views/components/Contact";

export default {
	components: {
		Contact,
	},
	bodyClass: "login-page",
	props: {
		header: {
			type: String,
			default: require("@/assets/img/annie-spratt-unsplash_sized.jpeg"),
		},
	},
	computed: {
		headerStyle() {
			return {
				backgroundImage: `url(${this.header})`,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
	display: flex;
	justify-content: center !important;
}

.contact-form {
	margin-top: 30px;
}

.text-center {
	color: black;
}

.md-has-textarea+.md-layout {
	margin-top: 15px;
}
</style>
